import type { Address } from "viem"
import type { Config } from "wagmi"

import type { EmitEvent } from "@/domains/core"
import type { IEventBus } from "@/domains/events"
import { EventEmitter, makeGroupId } from "@/domains/library"
import { LockDurationExtendedEvent } from "@/domains/lock/events"

import type { IIncreaseLockDurationActions } from "./interfaces"

interface IncreaseLockDurationInteractionParams {
  account: Address
  chainId: number
  config: Config
  vestedAddress: Address
  tokenId: number
  secondsToExtend: number
  emitter: EventEmitter<EmitEvent>
  eventBus: IEventBus
  onChainActions: IIncreaseLockDurationActions
}

export const increaseLockDurationInteraction = async ({
  account,
  chainId,
  config,
  vestedAddress,
  tokenId,
  secondsToExtend,
  emitter,
  eventBus,
  onChainActions,
}: IncreaseLockDurationInteractionParams) => {
  // Generate a unique group ID for this interaction instance
  const groupId = makeGroupId("increase-lock-duration")

  const result = await onChainActions.increaseLockDuration({
    account,
    chainId,
    config,
    vestedAddress,
    tokenId,
    secondsToExtend,
  })

  if (result.success) {
    eventBus.publish(new LockDurationExtendedEvent(groupId, tokenId, secondsToExtend, result.tx))
    emitter.emit("increase-lock-duration", {
      title: "Lock duration",
      description: `NFT #${tokenId} lock duration increased`,
      variant: "success",
    })
  }

  if (result.success === false) {
    emitter.emit("error-increasing-lock-duration", {
      title: "Lock duration failed",
      description: `Unable to increase lock duration for NFT #${tokenId}, reason ${result.error}`,
      variant: "error",
    })
  }

  return result
}
